import { DEVICE_TYPE_SOURCE, DeviceTypesProvider, fetchDeviceTypesFromAOM } from 'core/contexts/device-types';
import { SettingsLmsApiIntegrationContainer } from 'modules/settings/pods/settings-integrations/settings-integrations-lms-api-integration/settings-integrations-lms-api-integration.container';

export const SettingsLmsApiIntegrationScene = () => (
    <DeviceTypesProvider fetchStrategy={fetchDeviceTypesFromAOM} source={DEVICE_TYPE_SOURCE.AOM}>
        <SettingsLmsApiIntegrationContainer />
    </DeviceTypesProvider>
);

export default SettingsLmsApiIntegrationScene;
